export default __webpack_public_path__ + "static/media/FamilyNumber5.8e598cfb.svg";